module.exports = __webpack_public_path__ + "static/media/web_buttons_desktop.9ad274a9.svg";